import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  advancedSettingsByRole,
  AdvancedSettingsEnum,
  SettingsTypes,
} from '../containers/SettingsPage/types';
import { RootState } from './rootReducer';
import { userDetailsSelectors } from './userDetailsSlice';

export const settingsOptionsInitialState: SettingsTypes.SettingsOptionsInitialState =
  {
    filteredRobotOptions: [],
    advancedSettings: [],
  };

export const entitySettingsOptions = createSlice({
  name: 'entitySettingsOptions',
  initialState: settingsOptionsInitialState,
  reducers: {
    setFilteredOptions: (
      state,
      action: PayloadAction<SettingsTypes.FarmAstronaut[]>,
    ) => {
      state.filteredRobotOptions = action.payload;
    },
    setAdvancedSettings: (
      state,
      action: PayloadAction<AdvancedSettingsEnum[]>,
    ) => {
      state.advancedSettings = action.payload;
    },
    resetEntitySettingsOptions: () => settingsOptionsInitialState,
  },
});

export const {
  setFilteredOptions,
  setAdvancedSettings,
  resetEntitySettingsOptions,
} = entitySettingsOptions.actions;

// selectors
export const settingsOptionsSelectors = {
  selectFilteredAstronautOptions: (state: RootState) =>
    state.entitySettingsOptions.filteredRobotOptions,
  selectAdvancedSettings: (state: RootState) =>
    state.entitySettingsOptions.advancedSettings,
};

// Memoized selector determining available advanced settings options for filter
export const selectAdvancedSettingsByUserRoles = createSelector(
  userDetailsSelectors.selectCurrentUserRoles,
  (currentUserRoles) => {
    const result = currentUserRoles
      .flatMap((role) => {
        return advancedSettingsByRole[role];
      })
      // find unique values
      .filter((value, idx, arr) => {
        return arr.indexOf(value) === idx;
      });

    return result;
  },
);

export default entitySettingsOptions.reducer;
